export const convertObjectToArray = (obj: any): any[] =>
  Array.from(Object.keys(obj), (item) => obj[item]);
